import React, { useEffect, useState } from 'react';
import { usePoiSearch } from '../hooks/usePoiSearch';
import { useMap } from 'react-leaflet';
import { useMainMap } from '@bvt-features/mainmap/mainmap/hook/useMainMap';
import _ from 'lodash';
import { MarkerClusterWithChildren } from '@bvt-features/mainmap/cluster/component/MarkerCluster/MarkerClusterWithChildren';
import { MarkerPopup } from '../components/MarkerPopup';

export function PoiSearchMarkerContainer() {
  const POISEARCH = usePoiSearch();
  const initialMap = useMap();
  const MAINMAP = useMainMap();
  const [poi, setPoi] = useState([]);

  const ID = POISEARCH.selectedId;
  const SHOWALL = POISEARCH.isShowAll;
  const POILIST = POISEARCH.list;

  const styleFinder = _.find(
    MAINMAP.state.layerVisibilityList,
    (v) => v.key === 'POI_SEARCH'
  );

  useEffect(() => {
    if ((ID || SHOWALL) && poi.length > 0) {
      MAINMAP.registerLayer({
        key: 'POI_SEARCH',
        isActive: true,
        opacity: 1,
        title: 'POI Search',
        description: ['POI Search'],
      });
    }
    return () => {
      MAINMAP.removeLayer('POI_SEARCH');
    };
  }, [ID, SHOWALL, poi]);

  useEffect(() => {
    MAINMAP.updateLayer({
      key: 'POI_SEARCH',
      isActive: true,
      opacity: 1,
      title: 'POI Search',
      description: ['POI Search'],
    });
  }, [ID, SHOWALL]);

  // handle select list options
  useEffect(() => {
    if (ID) {
      const selected = POISEARCH.mapperListToDetail(ID);
      const icon = selected?.category_icon || '/Category/1.svg';
      const properties = {
        industry_name: selected?.industry_name,
        group_name: selected?.group_name,
        category_name: selected?.category_name,
        category_icon: icon,
        brand_name: selected?.brand_name,
        poi_name: selected?.poi_name,
        address: selected?.address,
        longitude: selected?.longitude,
        latitude: selected?.latitude,
        id_desa: selected?.id_desa,
        id_kota: selected?.id_kota,
        id_kecamatan: selected?.id_kecamatan,
        id_provinsi: selected?.id_provinsi,
        nama_desa: selected?.nama_desa,
        nama_kecamatan: selected?.nama_kecamatan,
        nama_kota: selected?.nama_kota,
        nama_provinsi: selected?.nama_provinsi,
      };
      const position = [+selected?.latitude, +selected?.longitude];
      initialMap?.setView(position);
      setPoi([
        {
          position,
          icon,
          properties,
        },
      ]);
    }
  }, [ID]);

  // handle press enter
  useEffect(() => {
    if (SHOWALL) {
      const coordinates = [];
      const data = POILIST?.map((item) => {
        const icon = item?.category_icon || '/Category/1.svg';
        const properties = {
          industry_name: item?.industry_name,
          group_name: item?.group_name,
          category_name: item?.category_name,
          category_icon: icon,
          brand_name: item?.brand_name,
          poi_name: item?.poi_name,
          address: item?.address,
          longitude: item?.longitude,
          latitude: item?.latitude,
          id_desa: item?.id_desa,
          id_kota: item?.id_kota,
          id_kecamatan: item?.id_kecamatan,
          id_provinsi: item?.id_provinsi,
          nama_desa: item?.nama_desa,
          nama_kecamatan: item?.nama_kecamatan,
          nama_kota: item?.nama_kota,
          nama_provinsi: item?.nama_provinsi,
        };
        const position = [+item?.latitude, +item?.longitude];
        coordinates.push(position);
        return {
          position,
          icon,
          properties,
        };
      });
      setPoi(data);
      if (coordinates.length > 0) {
        // Extract the bounding box (minLat, minLng, maxLat, maxLng)
        const latitudes = coordinates.map(coord => coord[0]);
        const longitudes = coordinates.map(coord => coord[1]);

        const minLat = Math.min(...latitudes);
        const maxLat = Math.max(...latitudes);
        const minLng = Math.min(...longitudes);
        const maxLng = Math.max(...longitudes);

        const bbox = [[minLat, minLng], [maxLat, maxLng]];
        initialMap?.fitBounds(bbox);
      }
    }
  }, [SHOWALL, POILIST]);

  return (
    <React.Fragment>
      {initialMap &&
        poi.length > 0 &&
        (POISEARCH.selectedId || POISEARCH?.isShowAll) &&
        (styleFinder?.isActive ? (
          <MarkerClusterWithChildren data={poi} opacity={styleFinder?.opacity}>
            <MarkerPopup />
          </MarkerClusterWithChildren>
        ) : null)}
    </React.Fragment>
  );
}
